import React, { useState } from "react";
import { Input } from "@/components/ui/input";

// Type-or-pick scene name: focusing opens earlier scene names from this production; typing narrows the list.
export default function SceneNameInput({ value, onChange, options, placeholder, testId }) {
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(-1);
  const q = value.trim().toLowerCase();
  const list = options.filter((o) => o.toLowerCase() !== q && o.toLowerCase().includes(q));
  const pick = (o) => { onChange(o); setOpen(false); setHi(-1); };
  const onKey = (e) => {
    if (!open || !list.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => (h + 1) % list.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => (h <= 0 ? list.length - 1 : h - 1)); }
    else if (e.key === "Enter" && hi >= 0) { e.preventDefault(); pick(list[hi]); }
  };
  return (
    <div className="relative min-w-0 flex-1">
      <Input className="bg-white" placeholder={placeholder} value={value} autoComplete="off" role="combobox" aria-expanded={open && list.length > 0}
        onChange={(e) => { onChange(e.target.value); setOpen(true); setHi(-1); }} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}
        onKeyDown={onKey} data-testid={testId} />
      {open && list.length > 0 && (
        <ul className="absolute inset-x-0 top-full z-50 mt-1 max-h-48 overflow-y-auto rounded-md border border-slate-200 bg-white py-1 shadow-lg" role="listbox" data-testid={`${testId}-options`}>
          <li className="px-3 pb-1 pt-0.5 text-[10px] font-bold uppercase tracking-wider text-slate-400">Earlier scenes</li>
          {list.map((o, j) => (
            <li key={o} role="option" aria-selected={j === hi} onMouseDown={(e) => { e.preventDefault(); pick(o); }}
              className={`cursor-pointer px-3 py-1.5 text-sm text-slate-700 transition-colors hover:bg-slate-100 ${j === hi ? "bg-slate-100" : ""}`}
              data-testid={`${testId}-option-${j}`}>{o}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
